import styled from 'styled-components';

const LegalTemplateStyle = styled.div`
	--privacyMarginTop: var(--sp15x);
	--containerCustomPadding: var(--sp31x);
	--privacyTitleMarginRight: var(--sp12x);
	--privacyMarginBottom: var(--sp15x);

	margin-top: var(--privacyMarginTop);

	.container {
		padding-left: var(--containerCustomPadding);
		padding-right: var(--containerCustomPadding);

		.privacies-wrap {
			.privacy {
				display: flex;
				margin-bottom: var(--privacyMarginBottom);

				&:last-child {
					margin-bottom: unset;
				}

				.privacy-title {
					width: 31%;
					margin-right: var(--privacyTitleMarginRight);
				}

				.editor-wrapper {
					flex: 1;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--privacyMarginTop: var(--sp12x);
		--containerCustomPadding: var(--sp22x);
		--privacyMarginBottom: var(--sp12x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--privacyMarginTop: var(--sp10x);
		--containerCustomPadding: var(--sp15x);
		--privacyMarginBottom: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--privacyMarginTop: var(--sp8x);
		--containerCustomPadding: var(--sp8x);
		--privacyTitleMarginRight: var(--sp8x);
		--privacyMarginBottom: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--privacyMarginTop: var(--sp8x);
		--containerCustomPadding: var(--sp6x);
		--privacyMarginBottom: var(--sp8x);

		.container {
			.privacies-wrap {
				.privacy {
					flex-direction: column;

					.privacy-title {
						width: unset;
						margin-bottom: var(--sp2x);
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--privacyMarginTop: var(--sp5x);
		--containerCustomPadding: var(--sp3x);
		--privacyMarginBottom: var(--sp5x);

		.container {
			.privacies-wrap {
				.privacy {
					flex-direction: column;

					.privacy-title {
						width: unset;
						margin-bottom: var(--sp1-5x);
					}
				}
			}
		}
	}
`;

export default LegalTemplateStyle;
